import script from "./InventoryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryView.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryView.vue?vue&type=style&index=0&id=a94ba050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a94ba050"]])

export default __exports__